<template>
    <div class="flex flex-wrap gap-2">
        <label
            v-for="color in colors"
            :key="color.name"
            :class="{ 'border-2 border-indigo-500': selected === color.name }"
            @click="selected = color.name"
        >
            <input type="hidden" :value="color.name" />
            <div
                class="h-8 w-8 p-1 rounded-full flex justify-center items-center"
                :class="[{ 'opacity-50': selected !== color.name }, color.dark]"
            >
                <div :class="color.medium" class="w-full h-full rounded-full"></div>
            </div>
        </label>
    </div>
</template>

<script>
export default {
    name: 'FormNamedColorPicker',
};
</script>
<script setup>
import { colors } from '@/TailwindColors.js';
import { useVModel } from '@vueuse/core';

let emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {
        type: String,
    },
});

const selected = useVModel(props, 'modelValue', emit);
</script>
